import { object, array } from "./";

export const createPortfolioSchema = object().shape({
  photo: array().required(),
});
